import { API, ENDPOINTS } from '@/app/services/api-url';
import AccountPaymentCard from '../../account-payment/account-payment-card/account-payment-card.vue';
import AccountPaymentCardUpdate from '../../account-payment/account-payment-card-update/account-payment-card-update.vue';

export default {
  name: 'billing-history-pay-invoice',
  components: {
    AccountPaymentCard,
    AccountPaymentCardUpdate,
  },
  props: {
    invoice: {
      type: [Object, String],
      required: true,
    },
    paymentMethod: {
      type: Object,
    },
    stripe: {
      type: Object,
    },
  },
  data() {
    return {
      selectedPaymentMethod: '',
      isLoading: false,
      error: '',
    };
  },
  computed: {
    card() {
      return this.paymentMethod && this.paymentMethod.card ? this.paymentMethod.card : {};
    },
    account() {
      return this.$store.getters['account/getActiveAccount'];
    },
  },
  methods: {
    handleUpdated() {
      this.selectedPaymentMethod = 'existing-payment-method';
      this.payInvoice();
    },
    payInvoice() {
      this.isLoading = true;
      const { uuid } = this.account;
      const payload = {
        accountID: uuid,
        invoiceID: this.invoice.id,
      };
      return API.post(`${ENDPOINTS.POST_STRIPE_INVOICE}`, payload)
        .then((response) => {
          if (response.status === 200) {
            this.$emit('paid');
          }
          this.isLoading = false;
        })
        .catch((err) => {
          if (err.response.status === 402) {
            this.error = 'Payment failed. Please check you payment details and try again.';
          }
          this.isLoading = false;
          console.log(err);
        });
    },
  },
  watch: {
    selectedPaymentMethod(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.error = this.error !== '' ? '' : this.error;
      }
    },
    paymentMethod: {
      immediate: true,
      handler(pm) {
        if (pm && pm.card && pm.card.brand) {
          this.selectedPaymentMethod = 'existing-payment-method';
        } else {
          this.selectedPaymentMethod = 'new-payment-method';
        }
      },
    },
  },
};
